<template lang="pug">
  .header-info(v-if="data")
    .header-info__content
      .header-info__content__left
        .header-info__content__img
          img(
            v-if="logoWidth",
            :src="data.company_logo_url"
            :class="{ widthFixed: logoWidth/logoHeight >= 1, heightFixed: logoWidth/logoHeight < 1 }",
          )
        .header-info__content__text
          p
            span.title {{ data.vendor_name_ch }}
            span(v-if="data.is_storage").roster {{ $t('Roster') }}
            i(v-if="data.is_new").iconfont.icon-xin
          p
            span.title {{ data.vendor_name }}
          p
            el-tooltip(
              v-if="data.weibo_qr_code_url"
              placement="right",
              popper-class="supplier-info__qr-tooltip"
            )
              div(slot="content")
                img(
                  v-if="weiboQrWidth",
                  :src="data.weibo_qr_code_url"
                  :class="{ widthFixed: weiboQrWidth/weiboQrHeight >= 1, heightFixed: weiboQrWidth/weiboQrHeight < 1 }",
                )
              i.iconfont.icon-weibo(:style="{ color: 'red' }")
            el-tooltip(
              v-if="data.wechat_qr_code_url"
              placement="right",
              popper-class="supplier-info__qr-tooltip"
            )
              div(slot="content")
                img(
                  v-if="wechatQrWidth"
                  :src="data.wechat_qr_code_url"
                  :class="{ widthFixed: wechatQrWidth/wechatQrHeight >= 1, heightFixed: wechatQrWidth/wechatQrHeight < 1 }",
                )
              i.iconfont.icon-weixin(:style="{ color: '#31cfac' }")
            a(
              v-if="data.website_url"
              :href="data.website_url" target="_blank"
            )
              i.iconfont.icon-lianjie
              span {{ data.website_url }}
      .header-info__content__right(v-if="isVendor")
        el-button(
          @click="$router.push('/information/edit/general')"
        ) {{ $t('编辑') }}
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      data: null,
      logoWidth: null,
      logoHeight: null,
      weiboQrWidth: null,
      weiboQrHeight: null,
      wechatQrWidth: null,
      wechatQrHeight: null
    }
  },
  computed: {
    vendorId () {
      return this.$store.state.vendor.id
    },
    isVendor () {
      return this.$store.state.common.user.is_vendor
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      axios
        .get('/vendor/vendor/getBasicInfo', {
          params: {
            vendor_id: this.vendorId
          }
        })
        .then((res) => {
          this.data = res.basic
          this.processImg()
        })
    },
    processImg () {
      const self = this
      let logo = new Image()
      logo.src = this.data.company_logo_url
      logo.addEventListener('load', function () {
        self.logoHeight = this.naturalHeight
        self.logoWidth = this.naturalWidth
      })
      let weiboQr = new Image()
      weiboQr.src = this.data.weibo_qr_code_url
      weiboQr.addEventListener('load', function () {
        self.weiboQrHeight = this.naturalHeight
        self.weiboQrWidth = this.naturalWidth
      })
      let wechatQr = new Image()
      wechatQr.src = this.data.wechat_qr_code_url
      wechatQr.addEventListener('load', function () {
        self.wechatQrHeight = this.naturalHeight
        self.wechatQrWidth = this.naturalWidth
      })
    }
  }
}
</script>

<style lang="stylus">
.header-info
  display flex
  margin-top: 16px
  margin-bottom: 24px

.header-info__content
  width 100%
  display flex
  justify-content space-between

.header-info__content__left
  width 85%
  display flex
  align-items end

.header-info__content__right
  display flex
  align-items center

.header-info__content__img
  height: 60px
  width: 60px
  padding 10px
  border: 1px solid #b7b7b7
  margin-right 20px
  display flex
  align-items center
  > .widthFixed
    width 60px
  > .heightFixed
    height 60px

.header-info__content__text
  p
    margin-top 0
    display: flex
    align-items: center
  p:nth-child(3)
    i
      margin-right 5px
    > a
      text-decoration none
  .title
    font-size 14px
    font-weight 600
    margin-right 20px
  .roster
    font-size 12px
    display inline-block
    padding 3px
    margin-right 20px
    border-radius 5px
  .roster
    border 1px solid #37a9e7
    color #37a9e7
  .icon-xin
    color #f49c20

.supplier-info__qr-tooltip
  > div:nth-child(1)
    height 100px
    width 100px
    display flex
    justify-content center
    align-items center
    > .widthFixed
        width 100px
    > .heightFixed
        width 100px
</style>
